import { FormattedTime } from '../../../../../ui';
import { StyledFormattedTime } from '../../../../flights/overview/ui/list/columns/Time';

interface ITimeCellProps {
	scheduledTimeStamp: number;
	actualTimestamp: number;
}

export default function TimeCell({
	scheduledTimeStamp,
	actualTimestamp,
}: ITimeCellProps) {
	return (
		<div>
			<FormattedTime
				value={scheduledTimeStamp}
				isStrikeThrough={scheduledTimeStamp !== actualTimestamp}
			/>
			{scheduledTimeStamp !== actualTimestamp && (
				<StyledFormattedTime
					value={actualTimestamp}
					isNewTime={scheduledTimeStamp !== actualTimestamp}
				/>
			)}
		</div>
	);
}
